import type { NavigationFailure, RouteLocationNormalized, RouteLocationNormalizedLoaded } from 'vue-router'

export async function afterRouterGuard(
  _: RouteLocationNormalized,
  __: RouteLocationNormalizedLoaded,
  failure?: NavigationFailure | void
) {
  if (failure) console.warn(failure)
}

export const windowReplace = (path: string) => {
  if (window.location.replace) {
    window.location.replace(path)
  } else if (window.history.replaceState) {
    window.history.replaceState(null, '', path)
    window.location.reload()
  } else {
    console.error('当前浏览器不支持location.replace以及history.replaceState方法')
  }
}
